import classNames from 'classnames';
import { useState, useCallback } from 'react';
import { resetColumns, setAltViewColumns } from '../blocks/results-block/helpers/setupColumns';
import SmallGridIcon from './icons/SmallGridIcon';
import LargeGridIcon from './icons/LargeGridIcon';
const ViewChange = ( { attributes, setColumns, setMobileColumns, isAbsolute = false } ) => {
	const {
		defaultView = 'large-grid',
		viewPickerLabel,
	} = attributes;

	const [ activeView, setActiveView ] = useState( defaultView );

	const hasLabel = viewPickerLabel && viewPickerLabel.length > 0;

	const componentClasses = classNames( [
		'qec-view-change',
		isAbsolute ? 'qec-view-change--absolute' : '',
	] );

	const buttonSmallGridClasses = classNames( [
		'qec-view-change__button',
		'qec-view-change__button--small-grid',
		activeView === 'small-grid' ? 'qec-view-change__button--active' : '',
	] );

	const buttonLargeGridClasses = classNames( [
		'qec-view-change__button',
		'qec-view-change__button--large-grid',
		activeView === 'large-grid' ? 'qec-view-change__button--active' : '',
	] );

	const onClickSmallGrid = useCallback( () => {
		setActiveView( 'small-grid' );
		if ( defaultView === 'small-grid' ) {
			resetColumns( setColumns, setMobileColumns, attributes );
		} else {
			setAltViewColumns( setColumns, setMobileColumns, attributes );
		}
	}, [ defaultView, setColumns, setMobileColumns, attributes ] );

	const onClickLargeGrid = useCallback( () => {
		setActiveView( 'large-grid' );
		if ( defaultView === 'large-grid' ) {
			resetColumns( setColumns, setMobileColumns, attributes );
		} else {
			setAltViewColumns( setColumns, setMobileColumns, attributes );
		}
	}, [ defaultView, setColumns, setMobileColumns, attributes ] );

	return (
		<div className={ componentClasses }>
			<div className="qec-view-change__wrapper">
				{ hasLabel && <span className="qec-view-change__label">{ viewPickerLabel }</span> }
				<button onClick={ onClickSmallGrid } className={ buttonSmallGridClasses } aria-label="Change view to small Grid">
					<SmallGridIcon />
				</button>
				<button onClick={ onClickLargeGrid } className={ buttonLargeGridClasses } aria-label="Change view to large Grid">
					<LargeGridIcon />
				</button>
			</div>
		</div>
	);
};

export default ViewChange;
